import { useSearchParams } from "react-router-dom";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import StyledWrapper from "./style";


type TProps = {
  onClose?: Function
}

const DangerousZoneAlertContent = ({ onClose }: TProps) => {

  return (
    <StyledWrapper.Container>
      <StyledWrapper.Icon>
        <img
          src="/images/locationAlert.svg"
          alt="Historial"
          width="41"
          color="red"
        />
      </StyledWrapper.Icon>
      <StyledWrapper.Title>
        La dirección ingresada corresponde a una zona peligrosa
      </StyledWrapper.Title>

      <StyledWrapper.Subtitle>
        Lavoris gestionará su solicitud
      </StyledWrapper.Subtitle>

      <StyledWrapper.Subtitle></StyledWrapper.Subtitle>
      <StyledWrapper.ButtonsContainer>
        <PrimaryButton
          type="button"
          text="Aceptar"
          styles="bg-red-400 text-white font-bold hover:bg-opacity-80 w-auto px-[60px] m-auto"
          onClick={() => onClose && onClose()}
        />
      </StyledWrapper.ButtonsContainer>
    </StyledWrapper.Container>
  );
};

export default DangerousZoneAlertContent;
